'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import styles from './AboutTeacher.module.css';

const FALLBACK_AVATAR = '/images/demo-profile.png';
const FALLBACK_NAME = 'Teacher';
const FALLBACK_CAPTION = 'Passionate educator dedicated to helping students achieve their learning goals.';

export default function AboutTeacher({ teacher, teacherAvatarUrl }) {
  const router = useRouter();

  const teacherData = Array.isArray(teacher) ? teacher[0] : teacher;
  if (!teacherData?.id) return null;

  const computedName = `${teacherData?.firstName ?? ''} ${teacherData?.lastName ?? ''}`.trim();

  const name =
    (typeof teacherData?.name === 'string' && teacherData.name.trim()) ||
    (typeof teacherData?.displayName === 'string' && teacherData.displayName.trim()) ||
    (computedName.length ? computedName : null) ||
    FALLBACK_NAME;

  const captionText = String(teacherData?.description ?? '').trim();
  const caption = captionText || FALLBACK_CAPTION;

  const avatarSrc = teacherAvatarUrl || FALLBACK_AVATAR;

  const teacherHref = `/teacher-profile/${teacherData.id}`;

  const handleViewClasses = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const el = document.getElementById('upcoming-classes');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    router.push(`${teacherHref}#upcoming-classes`);
  };

  return (
    <section className={styles.section}>
      <div className={styles.wrapper}>
        <Link
          href={teacherHref}
          className={styles.avatarLink}
          aria-label={`View ${name}'s profile`}
        >
          <img
            className={styles.avatar}
            src={avatarSrc}
            alt={`${name} profile`}
            loading="lazy"
            onError={(e) => {
              e.currentTarget.onerror = null; // prevent loops
              e.currentTarget.src = FALLBACK_AVATAR;
            }}
          />
        </Link>

        <div className={styles.content}>
          <div className={styles.kicker}>Meet Your Teacher</div>

          <Link href={teacherHref} className={styles.nameLink}>
            <div className={styles.name}>{name}</div>
          </Link>

          <div className={styles.headline}>{caption}</div>

          <div className={styles.actions}>
            <button
              type="button"
              onClick={handleViewClasses}
              className={styles.primaryBtn}
            >
              Explore My Courses
            </button>

            <Link href={teacherHref} className={styles.secondaryBtn}>
              Ask A Question <span className={styles.icon}>💬</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}